<script>
  	import { onMount } from 'svelte';
	import http from '../api/http.js';
  	import {anchor, commands, deployments, key, list, logOut, monitor, moon, sun} from '../common/sidebarImages.js'
  	import { currentPage, loggedIn, branding } from "../store.js";
	import { createEventDispatcher } from 'svelte';
  	import {Link} from 'svelte-routing';
	const dispatch = createEventDispatcher();

	export let menuItems = [];
	let isExpanded = false;

  	let version = 'Unknown';

	export let activeLink = "";
	async function getVersion(){
		await http.get('/api/deploy/dashboard/system/version')
		.then(res => res.text())
		.then(data => {
			version = data;
		});
	}
    
    onMount(async () => {
		await getVersion();
	});
</script>

<div class="sidenav">
	<header class="{$branding.name == "OneShare" ? 'oneshare' : ''} {$branding.name == "Orbyt" ? 'orbyt' : ''}">
		<!-- svelte-ignore empty-block -->
		{#if $branding.theme === "ktsat" && isExpanded}
		{:else}
		<img alt="{$branding.name}" src="/themes/{$branding.theme}/product.png" height="60" class="header-image" >
		{/if}
		{#if !$branding.logoOnly}
    	<span id="product-name" class="fw-bold text-white">{$branding.name}</span>
		{/if}
	</header>
  	<div class="nav-items">
		<Link to="/" >
			<div class="menu-item {activeLink == 'home' ? 'active':'' }">
				<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-home"><path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/><polyline points="9 22 9 12 15 12 15 22"/></svg>
				<span class="text nav-text">Home</span>
			</div>
		</Link>
		<Link to="/vessels" >
		<div class="menu-item {activeLink == 'vessels' ? 'active':'' }">
          	<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-anchor icon"><circle cx="12" cy="5" r="3"></circle><line x1="12" y1="22" x2="12" y2="8"></line><path d="M5 12H2a10 10 0 0 0 20 0h-3"></path></svg>
			<span class="text nav-text">Vessels</span>
		</div>
		</Link>
    	<Link to="/computers">
		<div class="menu-item {activeLink == 'computers' ? 'active':'' }">
			<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-monitor icon"><rect x="2" y="3" width="20" height="14" rx="2" ry="2"></rect><line x1="8" y1="21" x2="16" y2="21"></line><line x1="12" y1="17" x2="12" y2="21"></line></svg>					
			<span class="text nav-text">Endpoints</span>
		</div>
		</Link>
    	<Link to="/packages">
		<div class="menu-item {activeLink == 'packages' ? 'active':'' }">
			<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-list icon"><line x1="8" y1="6" x2="21" y2="6"></line><line x1="8" y1="12" x2="21" y2="12"></line><line x1="8" y1="18" x2="21" y2="18"></line><line x1="3" y1="6" x2="3.01" y2="6"></line><line x1="3" y1="12" x2="3.01" y2="12"></line><line x1="3" y1="18" x2="3.01" y2="18"></line></svg>					
			<span class="text nav-text">Packages</span>
		</div>
		</Link>
    	<Link to="/deployments">
		<div class="menu-item {activeLink == 'deployments' ? 'active':'' }">
			<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-send icon"><line x1="22" y1="2" x2="11" y2="13"/><polygon points="22 2 15 22 11 13 2 9 22 2"/></svg>
			<span class="text nav-text">Deployments</span>
		</div>
		</Link>
    	<Link to="/commands">
		<div class="menu-item {activeLink == 'commands' ? 'active':'' }">
			<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-download icon"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/><polyline points="7 10 12 15 17 10"/><line x1="12" y1="15" x2="12" y2="3"/></svg>
			<span class="text nav-text">Installation Commands</span>
		</div>
		</Link>
    	<Link to="/credentials">
		<div class="menu-item {activeLink == 'credentials' ? 'active':'' } ">
			<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-key icon"><path d="M21 2l-2 2m-7.61 7.61a5.5 5.5 0 1 1-7.778 7.778 5.5 5.5 0 0 1 7.777-7.777zm0 0L15.5 7.5m0 0l3 3L22 7l-3-3m-3.5 3.5L19 4"></path></svg>					
			<span class="text nav-text">Credentials</span>
		</div>
		</Link>
  </div>

	<small class="version">{version}</small>
</div>

<style>
.d-flex{
	display: flex;
}
.sidenav {
	margin: 0;
	padding: 0;
	width: 100px;
	background-color: var(--sidebar-color);
	position: fixed;
	height: 100%;
	overflow: auto;
	z-index: 100;
	transition: all 0.3s ease;
	overflow-x: hidden;
	overflow-y: hidden;
}

.sidenav .nav-items{
  margin-top: 1.5rem;
}

.sidenav a {
  display: block;
  color: #bbc4ec;
  padding: 16px;
  text-decoration: none;
  margin-top: 3vh;
}

.sidenav .menu-item:hover {
  color: #fff;
}

.sidenav .menu-item.active{
	color: #fff;
}

.sidenav .menu-item{
	display: flex;
	flex-direction: column;
	margin-bottom: 1.2rem;
	color: var(--sidebar-icon-color)
}
.sidenav .menu-item svg{
  margin-left: auto;
  margin-right: auto;
}

.sidenav .menu-item span{
  font-size: 0.7em;
  text-align: center;
  font-weight: 500;
}

.sidenav header .image,
.sidenav .icon {
	min-width: 25px;
	border-radius: 4px;
}

.sidenav .icon.active{
	color: #fff!important;
}

.sidenav header .image {
    display: flex;
	  margin: 0.2em;
    align-items: center;
    justify-content: center;
}

    .sidenav header .image img {
        width: 40px;
        border-radius: 6px;
    }

.sidenav  header {
	margin-top: 20px;
	display: flex;
	align-items: center;
	justify-content: center;
	position: relative;
  flex-direction: column;
}

#product-name{
  font-weight: bold;
  text-align: center;
}

.sidenav header img{
	max-height: 40px;
	margin: 0.2rem;
	transition: all 0.3s ease;
}

.sidenav .icon {
	min-width: 20px;
	border-radius: 6px;
	height: 100%;
	display: flex;
	align-items: center;
	justify-content: center;
}

.sidenav .icon:hover{
	color: #fff;
}

.sidenav .icon .active{
	color: #fff!important;
}

@media(max-width: 800px){
	.sidenav{
		display: none;
	}

	.sidenav-toggle{
		display: none;
	}
}

.version{
	position: absolute;
	bottom: 10px;
	left: 0;
	width: 100%;
	text-align: center;
	color: #5D7191;
	font-size: 0.8em;
}

@media(max-width: 1600px){
	.sidenav .icon {
		font-size: 18px;
	}

	span{
		font-size: 14px;
	}
	
	.sidenav a {
		margin-top: 2.5vh;
	}
}

@media(max-width: 1400px){
	.sidenav .icon {
		font-size: 16px;
	}

	span{
		font-size: 12px;
	}
	
	.sidenav a {
		margin-top: 2.2vh;
	}
}
</style>